import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Notifies an open TV settings page to read the configuration after a remote reset. */
@Injectable({ providedIn: 'root' })
export class TvDisplaySettingsResetService {
  private readonly resetSubject = new Subject<void>();

  readonly reset$ = this.resetSubject.asObservable();

  notify(): void {
    this.resetSubject.next();
  }
}
